export const COURSE_STATUS = {
  COMPLETED: 0,
  ACTIVE: 1,
  UPCOMING: 2,
};

export const COURSE_CONTACT_EVENT = "course-contact-selected";

export const isCourseActive = (course) =>
  Number(course?.status) === COURSE_STATUS.ACTIVE;

export const isCourseUpcoming = (course) =>
  Number(course?.status) === COURSE_STATUS.UPCOMING;

export const isCourseVisible = (course) =>
  isCourseActive(course) || isCourseUpcoming(course);

export const getCourseDateLabel = (course, formatDate) => {
  if (isCourseUpcoming(course)) return "Próximamente";
  return formatDate(course?.start_date);
};

export const scrollToContactForm = (course) => {
  if (course?.id != null) {
    window.dispatchEvent(new CustomEvent(COURSE_CONTACT_EVENT, {
      detail: {
        id: String(course.id),
        title: course.title || course.nombre || "",
      },
    }));
  }

  document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
};
